
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/targets",
      function () {
        return require("private-next-pages/targets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/targets"])
      });
    }
  